module.exports = __webpack_public_path__ + "img/fuel-coupon-verify.84d19127.png";